import React, { Component } from 'react';

import { BRANCH_LOCATION } from '../../../shared/Config';
import { haversineDistanceMeters } from '../../../shared/utility';
import ChendhurLogowithbg from '../../../assets/images/Chenthoor_landscape_Logo.png';

// Location gate for QR ordering — hard-blocks entry unless the customer's
// device is within BRANCH_LOCATION.radiusMeters of the restaurant. No
// soft-warn/proceed-anyway path: every non-'ok' status is terminal until a
// retry succeeds. Reuses the exact geolocation + error-code pattern already
// in src/Containers/Auth/CheckIn.js (an unrelated HR check-in feature) —
// same navigator.geolocation.getCurrentPosition call, same switch(error.code).
const MESSAGES = {
    checking: 'Checking your location…',
    denied: "Location access was denied. We can only take orders from inside the restaurant — please allow location access and try again.",
    unavailable: "We couldn't determine your location. Please try again.",
    timeout: 'Locating you took too long. Please try again.',
    unsupported: "Your browser doesn't support location access, so we can't verify you're at the restaurant.",
    'out-of-range': "You don't seem to be at the restaurant right now, so ordering isn't available from here.",
};

class LocationGate extends Component {

    state = { status: 'checking' };

    componentDidMount() {
        this.check();
    }

    check = () => {
        this.setState({ status: 'checking' });

        if (!navigator.geolocation) {
            this.setState({ status: 'unsupported' });
            return;
        }

        navigator.geolocation.getCurrentPosition(
            (position) => {
                const { latitude, longitude } = position.coords;
                const distance = haversineDistanceMeters(
                    latitude, longitude,
                    BRANCH_LOCATION.latitude, BRANCH_LOCATION.longitude
                );

                this.setState({
                    status: distance <= BRANCH_LOCATION.radiusMeters ? 'ok' : 'out-of-range',
                });
            },
            (error) => {
                switch (error.code) {
                    case error.PERMISSION_DENIED:
                        this.setState({ status: 'denied' });
                        break;
                    case error.POSITION_UNAVAILABLE:
                        this.setState({ status: 'unavailable' });
                        break;
                    case error.TIMEOUT:
                        this.setState({ status: 'timeout' });
                        break;
                    default:
                        this.setState({ status: 'unavailable' });
                }
            },
            { enableHighAccuracy: true, timeout: 10000 }
        );
    };

    render() {
        const { status } = this.state;

        if (status === 'ok') {
            return this.props.children;
        }

        return (
            <div className="pos-auth-wrapper">
                <div className="pos-auth-card">
                    <div className="pos-auth-header">
                        <img src={ChendhurLogowithbg} alt="Chenthoor" className="pos-auth-logo" />
                    </div>
                    <div className="pos-auth-body">
                        {status === 'checking' ? (
                            <p className="pos-auth-hint">{MESSAGES.checking}</p>
                        ) : (
                            <>
                                <div className="pos-auth-error">{MESSAGES[status]}</div>
                                <button type="button" className="pos-auth-submit" onClick={this.check}>
                                    Try Again
                                </button>
                            </>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default LocationGate;
